import React from 'react'

const Form = () => {
  return (
    <div className='hero'>
        <div className='content'>
            <h1>Contact Us</h1>
            <p>We hope to hear from you soon!</p>
        </div>
    </div>
  )
}

export default Form